var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-wrapper",
        { staticClass: "form-wrapper", attrs: { validator: _vm.$v.member } },
        [
          _c(
            "div",
            { staticClass: "custom-section-wrapper" },
            [
              _c("h5", [_vm._v("Payment Information")]),
              _c(
                "div",
                [
                  _c(
                    "form-group",
                    { attrs: { name: "company", label: "Company" } },
                    [
                      _c("md-input", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "company", $$v)
                          },
                          expression: "member.company",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "custom-form-group" },
                [
                  _c(
                    "form-group",
                    {
                      attrs: {
                        name: "businessRegistrationNumber",
                        label: _vm.businessRegistrationNumberLabel,
                      },
                    },
                    [
                      _c("md-input", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.businessRegistrationNumber,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.member,
                              "businessRegistrationNumber",
                              $$v
                            )
                          },
                          expression: "member.businessRegistrationNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showAcnField
                ? _c(
                    "div",
                    { staticClass: "custom-form-group" },
                    [
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "businessCompanyNumber",
                            label: "ACN",
                          },
                        },
                        [
                          _c("md-input", {
                            attrs: { disabled: !_vm.isAllowedToUpdate },
                            model: {
                              value: _vm.member.businessCompanyNumber,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "businessCompanyNumber",
                                  $$v
                                )
                              },
                              expression: "member.businessCompanyNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "custom-form-group margin-right-0" },
                [
                  _c(
                    "form-group",
                    {
                      attrs: {
                        name: "accountsEmail",
                        label: "Accounts Email Address",
                      },
                    },
                    [
                      _c("md-input", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.accountsEmail,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "accountsEmail", $$v)
                          },
                          expression: "member.accountsEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("business-entities-dropdown", {
                attrs: { disabled: !_vm.isAllowedToUpdate },
                model: {
                  value: _vm.member.invoicingBusinessEntityId,
                  callback: function ($$v) {
                    _vm.$set(_vm.member, "invoicingBusinessEntityId", $$v)
                  },
                  expression: "member.invoicingBusinessEntityId",
                },
              }),
              _c("div", { staticClass: "invoice-settings-row" }, [
                _c(
                  "div",
                  { staticClass: "invoice-settings-col" },
                  [
                    _c(
                      "form-group",
                      {
                        attrs: {
                          name: "rateGroup",
                          label: "Default Service Package",
                        },
                      },
                      [
                        _c(
                          "md-select",
                          {
                            attrs: { disabled: !_vm.isAllowedToUpdate },
                            model: {
                              value: _vm.rateGroupId,
                              callback: function ($$v) {
                                _vm.rateGroupId = $$v
                              },
                              expression: "rateGroupId",
                            },
                          },
                          _vm._l(_vm.rateGroups, function (item) {
                            return _c(
                              "md-option",
                              {
                                key: item.rateGroupId,
                                attrs: { value: item.rateGroupId },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(item.rateGroupName) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "invoice-settings-col" }, [
                  _c(
                    "div",
                    { staticClass: "skillfield-container" },
                    [
                      _vm.member.invoiceLineTypes != null &&
                      _vm.member.invoiceLineTypes.length > 0
                        ? _c("label", { attrs: { for: "invoiceLineTypes" } }, [
                            _vm._v(
                              "\n                            Invoice Types\n                        "
                            ),
                          ])
                        : _vm._e(),
                      _c("multiselect", {
                        attrs: {
                          options: _vm.invoiceLineOptions,
                          multiple: true,
                          "close-on-select": true,
                          placeholder: "Pick invoice types",
                          label: "name",
                          "track-by": "key",
                          disabled: !_vm.isAllowedToUpdate,
                        },
                        model: {
                          value: _vm.member.invoiceLineTypes,
                          callback: function ($$v) {
                            _vm.$set(_vm.member, "invoiceLineTypes", $$v)
                          },
                          expression: "member.invoiceLineTypes",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm.isNoRollUpSelected
                  ? _c(
                      "div",
                      { staticClass: "invoice-settings-col" },
                      [
                        _c(
                          "form-group",
                          {
                            attrs: {
                              name: "teamMemberInvoiceTemplateType",
                              label: "Invoice Template",
                            },
                          },
                          [
                            _c(
                              "md-select",
                              {
                                attrs: { disabled: !_vm.isAllowedToUpdate },
                                model: {
                                  value:
                                    _vm.member.teamMemberInvoiceTemplateType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.member,
                                      "teamMemberInvoiceTemplateType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "member.teamMemberInvoiceTemplateType",
                                },
                              },
                              _vm._l(
                                _vm.invoiceTemplateOptions,
                                function (item) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: item.key,
                                      attrs: { value: item.key },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(item.name) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm.rateGroupId != -1
                ? _c(
                    "div",
                    { staticClass: "custom-form-group custom-sp-container" },
                    [
                      _c("div", [
                        _c("label", [
                          _vm._v("Apply the Service Package to the following:"),
                        ]),
                      ]),
                      _c(
                        "div",
                        _vm._l(_vm.applyRatesTo, function (type, index) {
                          return _c(
                            "md-checkbox",
                            {
                              key: index,
                              attrs: {
                                value: type.key,
                                disabled: !_vm.isAllowedToUpdate,
                              },
                              model: {
                                value: _vm.applyRatesToValue,
                                callback: function ($$v) {
                                  _vm.applyRatesToValue = $$v
                                },
                                expression: "applyRatesToValue",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(type.label) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "skillfield-container" },
                [
                  _c("multiselect", {
                    ref: "tagsMultiselect",
                    attrs: {
                      options: _vm.tags,
                      multiple: true,
                      "close-on-select": true,
                      placeholder: "Tags",
                      label: "name",
                      disabled: !_vm.isAllowedToUpdate,
                      "track-by": "tagId",
                    },
                    model: {
                      value: _vm.member.tags,
                      callback: function ($$v) {
                        _vm.$set(_vm.member, "tags", $$v)
                      },
                      expression: "member.tags",
                    },
                  }),
                ],
                1
              ),
              _c("payment-method-inputs", {
                staticClass: "custom-payment-container",
                attrs: { detail: _vm.member, disabled: !_vm.isAllowedToUpdate },
              }),
              _c(
                "div",
                [
                  _c(
                    "form-group",
                    {
                      attrs: {
                        name: "invoiceWeeklyMinimumAmount",
                        label: "Weekly Minimum (mon -> sun)",
                      },
                    },
                    [
                      _vm.member.invoiceWeeklyMinimumAmount
                        ? _c("span", { staticClass: "currency-container" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._f("currency")(
                                    null,
                                    _vm.user.teamCurrency,
                                    true
                                  )
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _c("md-input", {
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        model: {
                          value: _vm.member.invoiceWeeklyMinimumAmount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.member,
                              "invoiceWeeklyMinimumAmount",
                              _vm._n($$v)
                            )
                          },
                          expression: "member.invoiceWeeklyMinimumAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "custom-switch" },
                [
                  _c("label", { staticClass: "label-text" }, [
                    _vm._v(
                      "\n                    Apply tax for invoicing?\n                "
                    ),
                  ]),
                  _c("md-switch", {
                    attrs: { disabled: !_vm.isAllowedToUpdate },
                    model: {
                      value: _vm.member.shouldApplyTax,
                      callback: function ($$v) {
                        _vm.$set(_vm.member, "shouldApplyTax", $$v)
                      },
                      expression: "member.shouldApplyTax",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "md-layout" }, [
            _c(
              "div",
              { staticClass: "on-hold-container md-layout-item" },
              [
                _c(
                  "div",
                  { staticClass: "header-section" },
                  [
                    _c("h5", { staticClass: "section-title" }, [
                      _vm._v("On Hold Days"),
                    ]),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-button md-primary",
                        attrs: { disabled: !_vm.isAllowedToUpdate },
                        on: { click: _vm.addNewOnHoldRange },
                      },
                      [
                        _c("md-icon", [_vm._v("add")]),
                        _vm._v(
                          "\n                        Add On Hold Day\n                    "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.hasNoOnHoldDays
                  ? _c(
                      "md-table",
                      {
                        staticClass: "custom-paginated-table onhold-day-table",
                      },
                      [
                        _c(
                          "md-table-row",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("md-table-head", [_vm._v("Reason")]),
                            _c("md-table-head", { staticClass: "start-date" }, [
                              _vm._v("Start Date"),
                            ]),
                            _c("md-table-head", { staticClass: "end-date" }, [
                              _vm._v("End Date"),
                            ]),
                            _c("md-table-head", [_vm._v("Actions")]),
                          ],
                          1
                        ),
                        _vm._l(_vm.onHoldDays, function (onHoldDay, index) {
                          return _c(
                            "md-table-row",
                            { key: index, staticClass: "row-data" },
                            [
                              _c(
                                "md-table-cell",
                                { staticClass: "reason-column" },
                                [
                                  onHoldDay.inEditMode || onHoldDay.inAddMode
                                    ? _c(
                                        "form-group",
                                        { attrs: { name: "reason" } },
                                        [
                                          _c("md-input", {
                                            attrs: {
                                              maxlength: "100",
                                              disabled: !_vm.isAllowedToUpdate,
                                            },
                                            model: {
                                              value: onHoldDay.reason,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  onHoldDay,
                                                  "reason",
                                                  $$v
                                                )
                                              },
                                              expression: "onHoldDay.reason",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c("p", [
                                        _vm._v(_vm._s(onHoldDay.reason)),
                                      ]),
                                ],
                                1
                              ),
                              _c(
                                "md-table-cell",
                                { staticClass: "start-date" },
                                [
                                  onHoldDay.inEditMode || onHoldDay.inAddMode
                                    ? _c("md-datepicker", {
                                        attrs: {
                                          "md-immediately": "",
                                          "md-debounce": 100,
                                          "md-model-type": String,
                                          disabled: !_vm.isAllowedToUpdate,
                                        },
                                        model: {
                                          value: onHoldDay.fromDate,
                                          callback: function ($$v) {
                                            _vm.$set(onHoldDay, "fromDate", $$v)
                                          },
                                          expression: "onHoldDay.fromDate",
                                        },
                                      })
                                    : _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transformDate(
                                              onHoldDay.fromDate
                                            )
                                          )
                                        ),
                                      ]),
                                  onHoldDay.isTouched &&
                                  onHoldDay.fromDate == null
                                    ? _c(
                                        "span",
                                        { staticClass: "error error-message" },
                                        [
                                          _vm._v(
                                            "\n                                Start Date is required.\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  onHoldDay.isTouched &&
                                  onHoldDay.fromDate != null &&
                                  onHoldDay.toDate != null &&
                                  !_vm.$_isValidDateRange(
                                    onHoldDay.fromDate,
                                    onHoldDay.toDate
                                  )
                                    ? _c(
                                        "span",
                                        { staticClass: "error error-message" },
                                        [
                                          _vm._v(
                                            "\n                                Invalid date range.\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "md-table-cell",
                                { staticClass: "start-date" },
                                [
                                  onHoldDay.inEditMode || onHoldDay.inAddMode
                                    ? _c("md-datepicker", {
                                        attrs: {
                                          "md-immediately": "",
                                          "md-debounce": 100,
                                          "md-model-type": String,
                                          disabled: !_vm.isAllowedToUpdate,
                                        },
                                        model: {
                                          value: onHoldDay.toDate,
                                          callback: function ($$v) {
                                            _vm.$set(onHoldDay, "toDate", $$v)
                                          },
                                          expression: "onHoldDay.toDate",
                                        },
                                      })
                                    : onHoldDay.toDate
                                    ? _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.transformDate(onHoldDay.toDate)
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "md-table-cell",
                                { staticClass: "action-columns" },
                                [
                                  !onHoldDay.inEditMode && !onHoldDay.inAddMode
                                    ? _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-warning md-just-icon md-round",
                                          attrs: {
                                            title: "Edit on hold day",
                                            disabled: !_vm.isAllowedToUpdate,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editOnholdDay(
                                                onHoldDay
                                              )
                                            },
                                          },
                                        },
                                        [_c("md-icon", [_vm._v("edit")])],
                                        1
                                      )
                                    : _vm._e(),
                                  onHoldDay.inEditMode || onHoldDay.inAddMode
                                    ? _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-success md-just-icon md-round",
                                          attrs: {
                                            title: "Add",
                                            disabled: !_vm.isAllowedToUpdate,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addChangesToOnHold(
                                                onHoldDay
                                              )
                                            },
                                          },
                                        },
                                        [_c("md-icon", [_vm._v("check")])],
                                        1
                                      )
                                    : _vm._e(),
                                  !onHoldDay.inEditMode || onHoldDay.inAddMode
                                    ? _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-danger md-just-icon md-round",
                                          attrs: {
                                            title: "Delete on hold day",
                                            disabled: !_vm.isAllowedToUpdate,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteOnHoldDay(
                                                onHoldDay
                                              )
                                            },
                                          },
                                        },
                                        [_c("md-icon", [_vm._v("delete")])],
                                        1
                                      )
                                    : _vm._e(),
                                  onHoldDay.inEditMode
                                    ? _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-info md-just-icon md-round",
                                          attrs: {
                                            title: "Undo changes",
                                            disabled: !_vm.isAllowedToUpdate,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.undoChangesOnHoldDay(
                                                onHoldDay
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("md-icon", [
                                            _vm._v("restart_alt"),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                !_vm.hasNoOnHoldDays
                  ? _c("div", { staticClass: "text-center" }, [
                      _c("p", { staticClass: "no-result-message" }, [
                        _vm._v("No on hold days."),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "custom-section-wrapper" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary pull-right",
                  attrs: { type: "submit", disabled: !_vm.isAllowedToUpdate },
                  on: { click: _vm.validateForm },
                },
                [_vm._v("\n                Save\n            ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }